import { makeTr, type LandingLocale, localePath } from "@/lib/landing/locale";
import { Container, CtaAnchor, CtaLink, Section } from "./primitives";

/** The closing ask, on the closing surface it shares with the footer (Landing.tsx). */
export function FinalCta({ locale }: { locale: LandingLocale }) {
  const tr = makeTr(locale);
  return (
    <Section id="zacit" labelledBy="cta-title" tone="none" glow="center" className="pb-16 sm:pb-20">
      <Container className="flex flex-col items-center text-center">
        <h2
          id="cta-title"
          className="max-w-2xl text-3xl font-semibold leading-[1.1] tracking-tight sm:text-5xl"
        >
          {tr("Ať se platby párují samy", "Let your payments match themselves")}
        </h2>
        <p className="mt-5 max-w-xl text-base leading-relaxed text-muted-foreground sm:text-lg">
          {tr(
            "Připojte Fio účet a doklady k platbám najde Zettl.",
            "Connect your Fio account and Zettl finds the documents for your payments."
          )}
        </p>
        <div className="mt-9 flex w-full flex-col justify-center gap-3 sm:w-auto sm:flex-row">
          <CtaLink
            to={localePath(locale, "/auth?tab=register")}
            className="h-12 px-7 text-base"
            arrow
          >
            {tr("Vyzkoušet 14 dní zdarma", "Try it free for 14 days")}
          </CtaLink>
          <CtaAnchor href="#cenik" className="h-12 px-7 text-base">
            {tr("Ceník", "Pricing")}
          </CtaAnchor>
        </div>
      </Container>
    </Section>
  );
}
